var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlusBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.18,
    height: 19.18,
    viewBox: "0 0 19.18 19.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3288",
    "data-name": "Group 3288",
    transform: "translate(-1185.262 -230.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3287",
    "data-name": "Group 3287",
    transform: "translate(1185.262 230.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3561",
    "data-name": "Group 3561",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2813",
    "data-name": "Path 2813",
    d: "M163.842,162.5c0-1.96,0-6.969,0-8.929a1.934,1.934,0,0,1,1.859-2.151,1.967,1.967,0,0,1,1.946,2.1c.024,2.245.008,7.54.009,9.784q0,2.511,0,5.022a2.115,2.115,0,0,1-.945,1.958,1.726,1.726,0,0,1-1.888.069,1.794,1.794,0,0,1-.975-1.63c-.008-2.074,0-4.147,0-6.221",
    transform: "translate(-156.16 -151.417)",
    fill: "#03b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2814",
    "data-name": "Path 2814",
    d: "M128.969,198.137q-2.939,0-5.878,0a1.934,1.934,0,0,1-2.151-1.859,1.968,1.968,0,0,1,2.1-1.946c2.245-.024,4.49-.008,6.734-.009,1.674,0,6.4,0,8.072,0a2.115,2.115,0,0,1,1.958.945,1.726,1.726,0,0,1,.069,1.888,1.794,1.794,0,0,1-1.631.975c-2.074.008-7.2,0-9.271,0",
    transform: "translate(-120.939 -186.639)",
    fill: "#03b0ff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusBlue);
export default __webpack_public_path__ + "static/media/icon_plus_blue.d0e277e110fcd6e1ae9569f821dd6695.svg";
export { ForwardRef as ReactComponent };